<template>
  <div class="case">
    <div class="big-title">
      <p>移动案场</p>
      <div class="line"></div>
      <div class="desc">
        让房地产销售跳脱传统模式，不再受制于工程进度，将项目通过3D的方式提前呈现，前置蓄客，缩短营销去化周期；
        营销不再局限于线下售楼部，置业顾问更方便外出拓客；配合线上传播，客户不受约束、随时随地看房，让售楼更加立体，帮助项目快速去化。
      </div>
    </div>
    <div class="excite">
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>目价值点极致演绎，满足客户看房信息需求与兴奋点</h2>
        </div>
      </div>
      <div class="second-title">功能</div>
      <div class="content">
        <div class="item" v-for="item in feaList" :key="item.id">
          <div class="title">
            <img :src="item.img" />
            <p>{{ item.title }}</p>
          </div>
          <div class="line"></div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="excite-two">
      <div class="second-title">样机显示效果</div>
      <div class="effect">
        <div class="phone-box">
          <div class="row-tab">
            <div class="swiper-container myRow" ref="slider">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  :class="{ active: selectId == item.id }"
                  v-for="(item, index) in feaList"
                  :key="item.id"
                  @click="changeRowTabs(item.id, index)"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>

          <div class="column-tab">
            <div class="swiper-container myColumn" ref="columnSwiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="item in feaList"
                  :key="item.id"
                >
                  <img :src="item.img" />
                  <span>{{ item.title }}</span>
                  <div class="desc">
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="each">
      <div class="big-title">
        <p>交互案场</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line mar">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>价值意义</h2>
        </div>
      </div>
      <div class="value-content">
        <div class="item">
          <img src="../../static/images/product/value1.png" />
          <h2>创意内容更具带入感</h2>
          <p>
            VR全景让看房体验更通俗易懂/AR工法演示，房屋构造客户一目了然/数字化内容结合营销创意，惊喜感助力拓客。
          </p>
        </div>
        <div class="item">
          <img src="../../static/images/product/value2.png" />
          <h2>互动体验智能化获取信息</h2>
          <p>
            案场沟通更高：大屏互动体验，提升案场服务质量/手机微楼书，只要有电，哪里都是案场/跨屏切换，案场内外齐看房。
          </p>
        </div>
        <div class="item">
          <img src="../../static/images/product/value3.png" />
          <h2>数据统计与分析</h2>
          <p>
            真正实现案场全数字化：VR眼部追踪应用，准确获取用户行为数据/CRM+分销报备，实现销售数据化管理。
          </p>
        </div>
      </div>
      <div class="big-title mar">
        <p>案场交互设计蓝图</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>案场摄像头标准部署图</h2>
        </div>
        <p>
          售楼处作为楼盘形象展示的主要场所，不仅仅是接待、洽谈业务的地方，还是现场广告宣传的主要工具，通常也是实际的交易地点。因此，作为直接影响客户第一视觉效果的售楼处设计，一定要形象突出，体现楼盘特色，同时能激发客户的良好心理感受，增强购买欲望。
        </p>
      </div>
      <div class="blueprint">
        <div class="hall">
          <div class="left-top">
            <h2>互动营销大屏</h2>
            <p>
              通过互动营销的方式更加方便的实现VR全景看房、视频、图纸图片展示，加深客户的代入感增加购房的期望
            </p>
          </div>
          <div class="left-bottom">
            <h2>投影沙盘</h2>
            <p>
              投影沙盘系统通过星空效果，结合沙盘营造出很强的代入感，带给消费者很大的臆想空间
            </p>
          </div>
          <div class="right-bottom">
            <h2>LED透明屏</h2>
            <p>
              通过时尚、科技感的大屏，以视觉冲击强烈的效果提高售楼处的科技感和档次
            </p>
          </div>
        </div>
        <div class="desc-box">
          <div class="item">
            <img src="../../static/images/product/saoma.png" />
            <div class="right">
              <h2>扫码带走，一键分享</h2>
              <p>从案场引流留存至线上平台</p>
            </div>
          </div>
          <div class="item">
            <img src="../../static/images/product/wuxian.png" />
            <div class="right">
              <h2>无限空间，自由发挥</h2>
              <p>通过拖拽、漫游、双指缩放等手势操作</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <address class="five-footer">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a @click="jumpService">立即咨询</a>
    </address>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      rowSwiper: "",
      columnSwiper: "",
      selectId: 0,
      feaList: [
        {
          id: 0,
          img: require("../../static/images/product/loushu.png"),
          title: "电子楼书",
          desc: "品牌楼书，图文展示",
        },
        {
          id: 1,
          img: require("../../static/images/product/quwei.png"),
          title: "区位交通",
          desc: "从宏观到微观，介绍项目区位优势，展示项目周边配套",
        },
        {
          id: 2,
          img: require("../../static/images/product/shapan.png"),
          title: "三维沙盘",
          desc:
            "三维软件虚拟建模，日照变化、 四季变化，惊艳还原项目周边建筑与场景",
        },
        {
          id: 3,
          img: require("../../static/images/product/jianshang.png"),
          title: "户型鉴赏",
          desc: "在沙盘上清晰展示户型落位， 直观展示户型位置结构、布局风格",
        },
        {
          id: 4,
          img: require("../../static/images/product/yangban.png"),
          title: "全景样板间",
          desc: "多角度观赏样板间，跳转 或行走方式切换场景",
        },
        {
          id: 5,
          img: require("../../static/images/product/yuanlin.png"),
          title: "园林漫游",
          desc: "体验园林景观和商业氛围，如同身临其境",
        },
        {
          id: 6,
          img: require("../../static/images/product/system.png"),
          title: "SaaS系统",
          desc:
            " 集客户画像，浏览追溯，销售 管理于一体，提供可量化的项目营销依据",
        },
        {
          id: 7,
          img: require("../../static/images/product/xiaoshou.png"),
          title: "销售工具",
          desc: " 内置画笔，录屏，房贷计算，置业计划等销售常用小工具",
        },
      ],
    };
  },
  mounted() {
    let that = this;
    that.rowSwiper = new Swiper(".myRow", {
      slidesPerView: 3.5,
      freeMode: false,
      loop: false,
    });
    that.columnSwiper = new Swiper(".myColumn", {
      direction: "vertical",
      slidesPerView: "auto",
      on: {
        slideChange() {
          that.selectId = this.activeIndex;
          that.rowSwiper.slideTo(this.activeIndex, 300, false);
        },
      },
    });
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
    changeRowTabs(id, index) {
      this.selectId = id;
      this.columnSwiper.slideTo(index, 300, false);
    },
  },

  components: {},
};
</script>

<style lang="stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.css';

.effect {
  display: flex;
  justify-content: center;
  height: 668px;
  background: url('../../static/images/product/effect_bg.png') no-repeat;

  .phone-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('../../static/images/product/phone_box.png') no-repeat;
    width: 286px;
    height: 641px;
  }

  .row-tab {
    margin: -60px 20px 0 28px;
    width: 239px;
    cursor: pointer;

    .swiper-slide {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      text-align: center;
    }

    .swiper-slide.active {
      position: relative;
      color: #333333;
    }

    .swiper-slide.active::after {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      width: 21px;
      height: 1px;
      background: #333333;
    }
  }

  .column-tab {
    margin-top: 50px;
    margin-left: 64px;
    width: 229px;
    max-height: 438px;
    border-radius: 0px 0px 20px 20px;

    .swiper-container {
      width: 229px;
      max-height: 388px;
    }

    .swiper-slide {
      margin-bottom: 98px;
      width: 220px;

      span {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        padding-left: 10px;
      }

      .desc {
        width: 167px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 32px;
        margin-top: 24px;
      }
    }
  }
}

.case {
  width: 100%;
  padding: 139px 0 0;
  background-color: #fff;

  .big-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }

    .desc {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      text-align: center;
      width: 614px;
      margin: 50px 0 45px;
      line-height: 28px;
    }
  }

  .big-title.mar {
    margin-bottom: 75px;
  }

  .small-title {
    .frist-line {
      display: flex;
      align-items: center;
    }

    .frist-line.mar {
      margin: 92px 0 117px;
    }

    h2 {
      font-weight: bold;
      margin: 0 0 0 12px;
      font-size: 22px;
      font-weight: bold;
      color: #333333;
    }

    p {
      font-size: 18px;
      font-weight: 500;
      color: #666666;
      line-height: 26px;
      padding: 17px 0 0 40px;
    }
  }

  .second-title {
    font-size: 22px;
    font-weight: 800;
    color: #333333;
    margin: 80px 0 54px;
  }

  .excite-two {
    background: #FBFBFB;

    .second-title {
      font-size: 22px;
      font-weight: 800;
      color: #333333;
      margin: 0 0 54px 360px;
    }
  }

  .excite {
    padding: 68px 360px 71px;
    background: #FBFBFB;

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;

      .item {
        position: relative;
        box-sizing: border-box;
        padding: 55px 28px 28px;
        width: 283px;
        height: 237px;
        background: #FFFFFF;
        margin: 10px 10px 0 0;
        box-shadow: 0px 8px 12px 0px rgba(175, 175, 175, 0.07);

        .desc {
          margin-top: 26px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
        }

        .line {
          position: absolute;
          top: 109px;
          left: 65px;
          width: 185px;
          height: 3px;
          background: #E1e1e1;
        }
      }

      .line::after {
        position: absolute;
        content: '';
        top: 0px;
        left: 0px;
        width: 185px;
        height: 3px;
        background: #EDB50B;
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 1.5s;
      }

      .item:hover .line::after {
        transform: scaleX(1);
        transform-origin: left;
        background-color: #EDB50B;
      }

      .title {
        display: flex;
        align-items: center;

        img {
          padding-bottom: 15px;
          border-bottom: 3px solid #EDB50B;
        }

        p {
          box-sizing: border-box;
          padding: 0 40px 15px 26px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
        }
      }
    }
  }

  .each {
    padding: 68px 360px 133px;
    background: #fff;

    .value-content {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 161px;

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 292px;
        margin-right: 107px;

        h2 {
          margin-top: 12px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }

        p {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 28px;
          margin-top: 28px;
        }
      }
    }

    .blueprint {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 95px;

      .hall {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 614px;
        height: 318px;
        background: url('../../static/images/product/case_bg.png') center center;
        background-repeat: no-repeat;

        h2 {
          text-align: right;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
          margin-bottom: 18px;
        }

        p {
          text-align: right;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          line-height: 28px;
          color: #666666;
        }

        .left-top {
          position: absolute;
          left: -295px;
          top: 80px;
          width: 335px;
        }

        .left-bottom {
          position: absolute;
          left: -295px;
          top: 235px;
          width: 335px;
        }

        .right-bottom {
          position: absolute;
          left: 545px;
          top: 230px;
          width: 335px;

          h2 {
            text-align: left;
          }

          p {
            text-align: left;
          }
        }
      }

      .desc-box {
        display: flex;
        margin-top: 110px;

        .item {
          display: flex;
          width: 600px;
          height: 201px;
          justify-content: center;
          align-items: center;
          background: #FFFFFF;
          border: 1px solid #F0F0F0;
        }

        .right {
          margin-left: 22px;

          h2 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333333;
          }

          p {
            margin-top: 18px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
            line-height: 28px;
          }
        }
      }
    }
  }

  .five-footer {
    width: 100%;
    height: 160px;
    background: url('../../static/images/fiveG/bg(1).png');
    text-align: center;
    border-sizing: border-box;
    position: relative;
    z-index: 3;

    h3 {
      padding-top: 20px;
      font-size: 24px;
      line-height: 50px;
      color: #FFFDF9;
    }

    a {
      text-decoration: none;
      display: inline-block;
      width: 200px;
      height: 44px;
      margin: 16px auto;
      font-size: 18px;
      font-weight: bold;
      color: #FFFEFC;
      line-height: 44px;
      border: 1px solid #FFFEFC;
      border-radius: 5px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/MarketCase.vue